import { NetworkSite } from "../models/site";
import axiosConfig from "./axiosConfig";

interface NetworkSiteResponse {
  sites: NetworkSite[];
}

const getNetworkSite = async (
  authToken: string,
  orgId: string,
  networkSiteIdsChunkStr: string,
  userOrgId?: string
): Promise<NetworkSiteResponse> => {
  const queryArgs: string[] = [`siteIds=${networkSiteIdsChunkStr}`];
  if (userOrgId) {
    queryArgs.push(`userOrgId=${userOrgId}`);
  }
  const { data } = await axiosConfig.get(
    `/organisation/${orgId}/network_site?${queryArgs.join("&")}`,
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    }
  );
  return data;
};

export default getNetworkSite;
